(() => {
  const header = document.querySelector('[data-istmo-header]');
  const toggle = header?.querySelector('.menu-toggle');
  const menu = document.getElementById('mobile-menu');
  if (!header || !toggle || !menu) return;
  const desktop = window.matchMedia('(min-width: 721px)');
  const positionMenu = () => {
    if (menu.hidden) return;
    const top = Math.max(0, header.getBoundingClientRect().bottom);
    menu.style.top = `${top}px`;
    menu.style.maxHeight = `calc(100dvh - ${top}px)`;
  };
  const setMenu = (open, restoreFocus = false) => {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? toggle.dataset.menuCloseLabel : toggle.dataset.menuOpenLabel);
    menu.hidden = !open;
    positionMenu();
    if (restoreFocus) toggle.focus();
  };
  toggle.addEventListener('click', () => setMenu(menu.hidden));
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !menu.hidden) setMenu(false, true);
  });
  document.addEventListener('click', event => {
    if (!menu.hidden && !menu.contains(event.target) && !toggle.contains(event.target)) setMenu(false);
  });
  document.addEventListener('focusin', event => {
    if (!menu.hidden && !menu.contains(event.target) && !header.contains(event.target)) setMenu(false);
  });
  window.addEventListener('resize', () => desktop.matches ? setMenu(false) : positionMenu());
  window.addEventListener('scroll', positionMenu, { passive: true });
})();
